import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ErrorDialogComponent } from '../../../dialogs/error-dialog/error-dialog.component';
import { LoteNotificacaoSmsDTO } from '../../../dtos/lote-notificacao-sms-dto';
import { Util } from '../../../util/util';
import { LoteNotificacaoSms } from '../../lote-notificacao-sms';
import { NotificacaoSms } from '../../notificacao-sms';
import { NotificacoesSmsService } from '../../notificacoes-sms.service';
import { LoteNotificacaoSmsPK } from '../../pks/lote-notificacao-sms-pk';

@Component({
  selector: 'app-notificacao-cancelamento-detail',
  templateUrl: './notificacao-cancelamento-detail.component.html',
  styleUrls: ['./notificacao-cancelamento-detail.component.css']
})
export class NotificacaoCancelamentoDetailComponent implements OnInit {

  displayedColumns: string[] = ['nomePessoaNotificacao', 'numTelefone', 'status'];

  dto: LoteNotificacaoSmsDTO;

  loteNotificacaoSms: LoteNotificacaoSms;

  formularioDetalheNotificacaoCancelamento: FormGroup;

  data: any = [];

  dataSource: MatTableDataSource<any>;

  @ViewChild(MatSort) sort: MatSort | any;

  constructor(private notificacoesSmsService: NotificacoesSmsService,
    private router: Router,
    private formBuilder: FormBuilder,
    private dialog: MatDialog) {

    this.dto = history.state.dto;

    this.loteNotificacaoSms = new LoteNotificacaoSms();;

    this.formularioDetalheNotificacaoCancelamento = this.formBuilder.group({
      pk: null,
      loginUsuarioNotificacao: null,
      statusNotificacaoSms: null,
      tipoStatusNotificacao: null,
      listaNotificacaoSms: null,
      dscMotivoNotificacao: null,
      dscMensagemNotificacao: null,
    });

    this.dataSource = new MatTableDataSource<any>([]);

  }

  ngOnInit() {

    this.configurarForm();

  }

  gotoList() {
    this.router.navigate(['/notificacoesCancelamento'], {
      state: {
        filtroLoteNotificacaoSms: history.state.filtroLoteNotificacaoSms,
      }
    });
  }

  configurarForm(): void {

    const pk: LoteNotificacaoSmsPK | null = this.getPk();

    if (pk) {
      this.notificacoesSmsService.procurarLoteNotificacaoSmsPorPk(pk)
        .subscribe(data => {
          // console.log(data)

          this.loteNotificacaoSms = Object.assign(new LoteNotificacaoSms(), data);

          this.configurarAtributosNotificacao();

        }, error => {
          console.log(error);
        });
    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Não foi possível consultar a Notificação de Cancelmanto. Chave não encontrada!'
        }
      });
    }
  }

  getPk(): LoteNotificacaoSmsPK | null {

    let pk: LoteNotificacaoSmsPK | null = new LoteNotificacaoSmsPK();

    if (this.dto.numLote && this.dto.dataNotificacao && this.dto.tipoNotificacao) {
      pk.numLote = this.dto.numLote;
      pk.dataNotificacao = this.dto.dataNotificacao;
      pk.tipoNotificacao = this.dto.tipoNotificacao;
    } else {
      pk = null;
    }

    return pk;
  }

  configurarAtributosNotificacao(): void {
    this.formularioDetalheNotificacaoCancelamento.setValue(this.loteNotificacaoSms);

    this.formularioDetalheNotificacaoCancelamento.disable();

    this.configurarDataSource();
  }

  configurarDataSource(): void {

    const listaNotificacoes: Array<NotificacaoSms> = [];
    if (this.loteNotificacaoSms.listaNotificacaoSms) {
      this.loteNotificacaoSms.listaNotificacaoSms.forEach((element: any) => {
        listaNotificacoes.push(Object.assign(new NotificacaoSms, element));
      });
    }

    this.data = listaNotificacoes;
    this.dataSource = new MatTableDataSource<any>(this.data);
    this.dataSource.sort = this.sort;
  }


  mascaraFoneCustom(fone: string): [string, any] {

    return Util.mascaraFoneCustom(fone);

  }
}
